<template>
<v-container fluid grid-list-lg>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <v-card-title primary-title class="primary white--text headline">
          Try Topic Model
        </v-card-title>
        <v-card-text>
          <form>
            <v-layout row>
              <v-flex xs6>
                <v-text-field
                  label="ID"
                  v-model="id"
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="name">
                <v-text-field
                  label="Name"
                  v-model="name"
                  disabled
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-select
                dense
                label="Data Source"
                :items="dataSourcesCollection"
                v-model="dataSource"
                >
                </v-select>
              </v-flex>
              <v-flex xs6 v-if="dataSource == 2">
                <v-text-field
                v-model="randomDataCount"
                label="Random Data Count"
                type="number"
                v-validate="'required|integer'"
                data-vv-name="data count"
                :error-messages="errors.collect('data count')"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row v-if="dataSource == 1">
              <v-flex xs12>
                <v-textarea
                  label="Text to analyse"
                  v-model="text"
                  hint="Each line is analysing as a separate instance"
                  v-validate="'required'"
                  data-vv-name="text"
                  :error-messages="errors.collect('text')"
                >
                </v-textarea>
              </v-flex>
            </v-layout>
          </form>
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat depressed @click.native="cancel" :disabled="analyseLoading">Cancel</v-btn>
          <v-btn color="accent" class="white--text" depressed @click.native="validateBeforeSubmit(analyse)" :loading="analyseLoading" :disabled="analyseLoading || (!text && dataSource == 1)">Try</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
  <v-layout row wrap v-if="testSent">
    <v-flex>
      <v-card>
        <v-card-title primary-title class="headline">
          Result
        </v-card-title>
        <v-card-text>
          <v-layout row>
            <v-flex xs12>
              <v-combobox
                label="Search Topics"
                prepend-icon="search"
                clearable
                chips
                multiple
                :open-on-click="false"
                :items="topicModelTest.topicsCollection.map((c) => { return c.name })"
                v-model="topicModelTest.filter"
              ></v-combobox>
            </v-flex>
          </v-layout>
          <v-data-table
          :headers="topicModelTest.resultsTableHeaders"
          :items="filteredTopicModelTestResults"
          :rows-per-page-items="[10,25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
          >
          <template slot="items" slot-scope="props">
            <td>
              <template v-if="props.item.foundTopics && props.item.foundTopics.length > 0">
                <span
                v-for="(token, i) in props.item.tokens"
                :key="i">
                  <template v-if="token.topic">
                    <v-tooltip
                    top
                    :color="token.color"
                    >
                      <v-chip
                      slot="activator"
                      dark
                      small
                      text-color="white"
                      class="v-chip--select-multi"
                      :color="token.color"
                      >
                      {{token.text}}
                      </v-chip>
                      {{token.topic}}
                    </v-tooltip>
                  </template>
                  <template v-else>
                    {{token.text}}
                  </template>
                </span>
              </template>
              <template v-else>
                {{props.item.text}}
              </template>
            </td>
            <td>
              <template v-if="props.item.foundTopics && props.item.foundTopics.length > 0">
                <span
                v-for="(topic, i) in props.item.foundTopics"
                :key="i">
                  <v-chip
                  dark
                  small
                  text-color="white"
                  class="v-chip--select-multi"
                  :color="topic.color"
                  @click="if(!topicModelTest.filter.includes(topic.name)) { topicModelTest.filter.push(topic.name) }"
                  >
                  {{topic.name}}
                  </v-chip>
                </span>
              </template>
            </td>
          </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      dataSourcesCollection: [
        {
          value: 1,
          text: 'Manual Entry'
        },
        {
          value: 2,
          text: 'Random'
        }
      ],
      topicModelTest: {
        resultsTableHeaders: [
          {text: 'Text', sortable: false, value: 'text'},
          {text: 'Topics', sortable: false, value: 'topics'}
        ],
        results: [],
        topicsCollection: [],
        filter: []
      },
      testSent: false,
      analyseLoading: false,
      dataSource: 1,
      randomDataCount: 10,
      text: '',
      colorLibrary: ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green', 'light-green', 'lime', 'amber', 'orange', 'deep-orange', 'brown', 'blue-grey']
    }
  },
  computed: {
    filteredTopicModelTestResults () {
      return this.topicModelTest.results.filter((r) => {
        return !this.topicModelTest.filter || this.topicModelTest.filter.length === 0 || (r.foundTopics.some((t) => {
          return this.topicModelTest.filter.includes(t.name)
        }))
      })
    }
  },
  methods: {
    cancel () {
      this.$router.go(-1)
    },
    analyse () {
      this.analyseLoading = true
      this.testSent = false

      const texts = this.text.split('\n')

      this.axios.post(`/topic-models/${this.id}/try`, {
        texts: texts,
        data_source: this.dataSource,
        random_data_count: parseInt(this.randomDataCount)
      })
        .then(response => {
          let foundTopics = []
          let topicColors = {}
          let randomColorIndexes = []
          this.topicModelTest.results = response.data.map((r) => {
            for (let i = 0; r.found_topics && i < r.found_topics.length; i++) {
              const foundTopic = r.found_topics[i]
              if (!foundTopics.includes(foundTopic.name)) {
                foundTopics.push(foundTopic.name)
                let randomColorIndex = this.getRandomInt(0, 16)
                if (randomColorIndexes.length < 17 && randomColorIndexes.includes(randomColorIndex)) {
                  while (randomColorIndexes.includes(randomColorIndex)) {
                    randomColorIndex = this.getRandomInt(0, 17)
                  }
                }
                const topic = {
                  name: foundTopic.name,
                  color: randomColorIndexes.includes(randomColorIndex) ? `${this.colorLibrary[randomColorIndex]} darken-1` : `${this.colorLibrary[randomColorIndex]} lighten-1`
                }
                randomColorIndexes.push(randomColorIndex)
                topicColors[topic.name] = topic.color
                this.topicModelTest.topicsCollection.push(topic)
              }
              r.found_topics[i].color = topicColors[r.found_topics[i].name]
            }
            return {
              foundTopics: r.found_topics,
              text: r.original_text,
              tokens: r.tokens.map((t) => {
                return {
                  text: t.text,
                  topic: t.topic,
                  color: topicColors[t.topic]
                }
              })
            }
          })
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.testSent = true
          this.analyseLoading = false
        })
    },
    getRandomInt (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    }
  }
}
</script>

<style>

</style>
